import React from 'react';
import Box from '@mui/material/Box';
import Main from 'layouts/Main';
import { useTranslation } from 'react-i18next';
import { MapHero } from '@akyga/shared-ui/MapHero';
import { Helmet } from 'react-helmet';
import FeaturesWithCardRepresentation from './components/FeaturesWithCardRepresentation';
const QuoteSent = () => {
  const { t } = useTranslation();

  return (
    <Main>
      <Helmet>
        <title>{t('topbar.pages.support.whereToBuy')}</title>
      </Helmet>
      <Box>
        <MapHero />
      </Box>
      <Box>
        <FeaturesWithCardRepresentation />
      </Box>
    </Main>
  );
};

export default QuoteSent;
